
const digest = 'd1607857e7c38ab5fd11081278900e121052f3a8fa7c4f0517f0838cd65836f6';
const classes = {"wrapper":"_wrapper_m46w3_1","textWrapper":"_textWrapper_m46w3_6","buttonWrapper":"_buttonWrapper_m46w3_11"};
const css = `._wrapper_m46w3_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_m46w3_1 ._textWrapper_m46w3_6 {
  background-color: #eaedf3;
  margin: -34px -24px 24px -24px;
  padding: 24px;
}
._wrapper_m46w3_1 ._buttonWrapper_m46w3_11 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  